<div class="col-md-12" id="cfet-instant-verification-container">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/instant_verify.png">
    <img id="instant-verification-icon" src="assets/images/instant_verify.png" alt="instant verification icon">
  </picture>

  <div class="row" id="instant-verification-content">
    <div class="col-md-12">
      <h1 style="display:none;">Fix for sonar issues</h1>
      <h2 id="instant-verification-heading">
        <strong>{{cfetLabels.cfet_instant_verification.instant_verification_heading}}</strong></h2>
      <p id="instant-verification-desc">{{cfetLabels.cfet_instant_verification.instant_verification_desc}}</p>
    </div>
  </div>

  <div class="row col-md-12" id="instant-verification-footer-column">
    <button type="button" id="btn-continue" (click)="continueToProfile($event)" (keyup)="continueToProfile($event)"
      class="btn btn-alt btn-medium" tabindex="0">{{cfetButtonLabels.button_labels.continueToProfile}}</button>

    <a data-dismiss="modal" (click)="cancelCreation($event)" (keyup)="cancelCreation($event)" tabindex="0"
      id="cancel_link" class="cancel_link">
      {{cfetButtonLabels.button_labels.cancel}}</a>
  </div>

</div>